var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAirplay = function SvgAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airplay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "airplay_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.768 12.36 5 6A1 1 0 0 1 16 20H6a1 1 0 0 1-.768-1.64l5-6a1 1 0 0 1 1.536 0ZM11 14.562 8.135 18h5.73L11 14.562ZM19 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-1a1 1 0 0 1 0-2h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 1 0 2H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airplay_svg__a)",
    transform: "translate(-615 -104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airplay_svg__b)",
    transform: "translate(615 104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v20H0V0z"
  })))));
};

export default SvgAirplay;